var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDownArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 32 32",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M22.12 11.453 16 17.56l-6.12-6.107L8 13.333l8 8 8-8-1.88-1.88Z"
})));
export default SvgDownArrow;